import { useState } from "react";
import AccountInformation from "./account_information";
import FosterInformation from "./foster_information";
import Organization from "./organization";
const secondaryNavigation = [
  {
    key: "ACCOUNT",
    name: "Account Information",
    component: <AccountInformation />,
  },
  {
    key: "FOSTER",
    name: "Foster Information",
    component: <FosterInformation />,
  },
  {
    key: "ORGANIZATION",
    name: "Organization",
    component: <Organization />,
  },
];

function Account() {
  const [state, setState] = useState(secondaryNavigation[0].key);
  return (
    <>
      <main>
        <h1 className="sr-only">Account Settings</h1>

        <header className="border-b border-gray-200 dark:border-white/5">
          {/* Secondary navigation */}
          <nav className="flex overflow-x-auto py-4">
            <ul className="flex min-w-full flex-none gap-x-6 px-4 text-sm/6 font-semibold text-gray-500 sm:px-6 lg:px-8 dark:text-gray-400">
              {secondaryNavigation.map((item) => (
                <li key={item.name}>
                  <button
                    onClick={() => setState(item.key)}
                    className={
                      item.key === state
                        ? "text-indigo-600 dark:text-indigo-400"
                        : ""
                    }
                  >
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </header>
        {secondaryNavigation
          .filter((x) => x.key === state)
          .map((navItem) => navItem.component)}
      </main>
    </>
  );
}
export default Account;
